
import { supabase } from "@/integrations/supabase/client";
import { User } from "@supabase/supabase-js";

export type AuthError = {
  message: string;
};

export const authService = {
  /**
   * Sign in with email and password
   */
  login: async (email: string, password: string): Promise<{ user: User | null; error: AuthError | null }> => {
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) {
        return { user: null, error: { message: error.message } };
      }

      return { user: data.user, error: null };
    } catch (err) {
      console.error("Login error:", err);
      return { user: null, error: { message: "An unexpected error occurred" } };
    }
  },

  /**
   * Create a new user account
   */
  register: async (email: string, password: string): Promise<{ user: User | null; error: AuthError | null }> => {
    try {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
      });

      if (error) {
        return { user: null, error: { message: error.message } };
      }

      return { user: data.user, error: null };
    } catch (err) {
      console.error("Registration error:", err);
      return { user: null, error: { message: "An unexpected error occurred" } };
    }
  },

  /**
   * Sign out the current user
   */
  logout: async (): Promise<{ error: AuthError | null }> => {
    try {
      const { error } = await supabase.auth.signOut();

      if (error) {
        return { error: { message: error.message } };
      }

      return { error: null };
    } catch (err) {
      console.error("Logout error:", err);
      return { error: { message: "An unexpected error occurred" } };
    }
  },

  /**
   * Get the current logged in user
   */
  getCurrentUser: async (): Promise<User | null> => {
    try {
      const { data } = await supabase.auth.getUser();
      return data.user;
    } catch (err) {
      console.error("Get current user error:", err);
      return null;
    }
  },
};
